// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3wtjJ","footer":"ModalInfo_footer__3qAUB"};